export enum Locations {
	USERS = "/users",
	EDIT_USER = "/edit-user",
	EDIT_TOKENS = "/edit-tokens",
	VIEW_USER_LOGS = "/view-user-logs",
	SET_PASSWORD = "/set-password",
}
